import React from "react";
import PropTypes from "prop-types"
import { Alert, Panel } from "react-bootstrap";

const Warnings = props => (
  <div>
    <Panel bsStyle="warning">
      <Panel.Heading>
        <Panel.Title componentClass="h3">Warnings</Panel.Title>
      </Panel.Heading>
      <Panel.Body>
        <ul>
          {props.warnings.map(warning => (
            <li key={`${warning.run_id}-${warning.details}`}>
              {warning.run_id}: {warning.details}
            </li>
          ))}
        </ul>
      </Panel.Body>
    </Panel>
  </div>
);

const Completed = props => {
  const { data } = props;
  // {
  //   "summary": {
  //     "jobs": 1,
  //     "runsheets": 1,
  //     "items": 1
  //   },
  //   "runsheets": [
  //     2121992
  //   ]
  // }
  return (
    <div>
      <Alert bsStyle="success" className="upload-complete-alert">
        Upload complete
      </Alert>
      <Panel>
        <Panel.Heading>Summary</Panel.Heading>
        <Panel.Body>
          <ul>
            <li>Total runsheets: {data.summary.runsheets}</li>
            <li>Total jobs: {data.summary.jobs}</li>
            <li>Total items: {data.summary.items}</li>
          </ul>
        </Panel.Body>
      </Panel>
      {data.warnings ? (<Warnings warnings={data.warnings} />) : ("")}
    </div>
  );
};
Completed.propTypes = {
  data: PropTypes.shape({})
};
Completed.defaultProps = {
  data: {
    summary: {
      runsheets: 0,
      jobs: 0,
      items: 0
    },
    warnings: []
  }
};

export default Completed;



// WEBPACK FOOTER //
// ./src/components/runsheets/list/upload/Completed.js